import Vue from 'vue'

export default
{
    namespaced: true,
    
    state:
    {
        accounts: {},
    },

    getters:
    {
    },

    mutations:
    {
        updateAccounts (state, accounts) 
        {
            for (const account of accounts)
            {
                Vue.set(state.accounts, account.id, account)
            }
            state.accounts = state.accounts
        },
    },

    actions:
    {
    }
}


// WEBPACK FOOTER //
// ./src/stores/accounts.js